import { APP_LINKS, APP_SUB_MENUS, URL_PARAMS } from '@utils/variables';
import { useRouter } from 'next/router';
import { IUseCharacterRouter } from './useCharacterRouter.type';

function useCharacterRouter(): IUseCharacterRouter {
	const router = useRouter();
	const { c, s: currentSubpageId } = router.query || { c: 'false', s: undefined };
	const isInCustomizationView = c === 'true';

	const showCustomizationView = () => {
		router.push(
			{
				pathname: APP_LINKS.character.href,
				query: {
					[URL_PARAMS.subpage]: APP_SUB_MENUS.character.inventory.id,
					[URL_PARAMS.avatarCustomization]: 'true'
				}
			},
			undefined,
			{ shallow: true }
		);
	};

	const hideCustomizationView = () => {
		if (!isInCustomizationView) {
			console.error('Cannot hide customization view when it is not visible');
			return;
		}

		router.push(
			{
				pathname: APP_LINKS.character.href,
				query: {
					[URL_PARAMS.subpage]: APP_SUB_MENUS.character.inventory.id
				}
			},
			undefined,
			{ shallow: true }
		);
	};

	return {
		isInCustomizationView,
		showCustomizationView,
		hideCustomizationView,
		currentSubpageId: !!currentSubpageId ? String(currentSubpageId) : undefined
	};
}

export { useCharacterRouter };
